import * as React from 'react';

import { DOMAINS } from 'bundles/promo-template/constants/navigation';

export type PromoTemplateDomain = keyof typeof DOMAINS;

export type PromoTemplateDomainContextState = {
  domain: PromoTemplateDomain;
};

export const PromoTemplateDomainContext = React.createContext<PromoTemplateDomainContextState>({
  domain: DOMAINS.explore,
} as PromoTemplateDomainContextState);

export const PromoTemplateDomainProvider: React.LegacyFunctionComponentWithChildren<
  PromoTemplateDomainContextState
> = ({ children, domain }) => {
  return <PromoTemplateDomainContext.Provider value={{ domain }}>{children}</PromoTemplateDomainContext.Provider>;
};
